import React, {useEffect} from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useResponses from '../../hooks/useResponses'
import Page from '../../components/Page'
import ItemLoader, {RendererProps} from '../../components/ItemLoader'
import {Responses as SearchResponses} from '../../components/search'
import {BaseStats} from '../../components/EvaluationSessions'
import {getEvaluationSession} from '../../services/evaluationSession'
import type {Eval} from '../../services/types'

export const fetchEvaluationSession = getEvaluationSession

const EvaluationSessionSummary = ({item: evalSession, setItem}: RendererProps<Eval>) => {
  const {refresh} = useResponses()

  useEffect(() => {
    refresh({
      filters: {
        evaluation_session_id: evalSession.id,
        correct: false,
        fields: [
          'id',
          'correct',
          'raw_task_text',
          'parsed_response_text',
          'response_time_in_seconds',
          'correctness',
          'creation_date',
        ],
      },
    })
  }, [evalSession, refresh])

  return (
    <Page
      title={`Report for "${evalSession.evaluation_name}" on "${evalSession.evaluatee_name}"`}
      showTitle
    >
      <Stack spacing={4}>
        <Typography variant="h3" sx={{pt: 4}}>
          Basic statistics
        </Typography>
        <BaseStats {...evalSession} />

        <Typography variant="h3" sx={{pt: 4}}>
          Invalid responses
        </Typography>
        <SearchResponses searchbar />
      </Stack>
    </Page>
  )
}

const EvaluationSession: React.FC = () => (
  <ItemLoader itemName="evaluation session" renderer={EvaluationSessionSummary} />
)

export default EvaluationSession
